module.exports = __webpack_public_path__ + "static/media/integrate.2442ef77.svg";